export default {
      id: "icon--spa-usage",
      viewBox: "0 0 30.5 30.3",
      url: __webpack_public_path__ + "redesign-sprite.svg#icon--spa-usage",
      toString: function () {
        return this.url;
      }
    }